import { useDispatch, useSelector } from 'react-redux';

import { actions, customActions_page } from '@redux/actions';

//_____________________ PAGE ______________ //

//aboutUs
export const usePage_aboutUs = () => {
	const aboutUs = useSelector((state) => state.page.aboutUs);
	const dispatch = useDispatch();

	return {
		state: aboutUs,
		actions: customActions_page.aboutUs,
		dispatch: dispatch,
		setState: (values = {}, scope = '') => dispatch(actions.page_aboutUs_set(values, scope)),
		clearState: (values = {}, scope = '') => dispatch(actions.page_aboutUs_clear(values, scope)),
	};
};

//contactUs
export const usePage_contactUs = () => {
	const contactUs = useSelector((state) => state.page.contactUs);
	const dispatch = useDispatch();

	return {
		state: contactUs,
		actions: customActions_page.contactUs,
		dispatch: dispatch,
		setState: (values = {}, scope = '') => dispatch(actions.page_contactUs_set(values, scope)),
		clearState: (values = {}, scope = '') => dispatch(actions.page_contactUs_clear(values, scope)),
	};
};

//faq
export const usePage_faq = () => {
	const faq = useSelector((state) => state.page.faq);
	const dispatch = useDispatch();

	return {
		state: faq,
		actions: customActions_page.faq,
		dispatch: dispatch,
		setState: (values = {}, scope = '') => dispatch(actions.page_faq_set(values, scope)),
		clearState: (values = {}, scope = '') => dispatch(actions.page_faq_clear(values, scope)),
	};
};

//forms
export const usePage_forms = () => {
	const forms = useSelector((state) => state.page.forms);
	const dispatch = useDispatch();

	return {
		state: forms,
		actions: customActions_page.forms,
		dispatch: dispatch,
		setState: (values = {}, scope = '') => dispatch(actions.page_forms_set(values, scope)),
		clearState: (values = {}, scope = '') => dispatch(actions.page_forms_clear(values, scope)),
	};
};

//news
export const usePage_news = () => {
	const news = useSelector((state) => state.page.news);
	const dispatch = useDispatch();

	return {
		state: news,
		actions: customActions_page.news,
		dispatch: dispatch,
		setState: (values = {}, scope = '') => dispatch(actions.page_news_set(values, scope)),
		clearState: (values = {}, scope = '') => dispatch(actions.page_news_clear(values, scope)),
	};
};

//home
export const usePage_home = () => {
	const home = useSelector((state) => state.page.home);
	const dispatch = useDispatch();

	return {
		state: home,
		actions: customActions_page.home,
		dispatch: dispatch,
		setState: (values = {}, scope = '') => dispatch(actions.page_home_set(values, scope)),
		clearState: (values = {}, scope = '') => dispatch(actions.page_home_clear(values, scope)),
	};
};

//rateArchive
export const usePage_rateArchive = () => {
	const rateArchive = useSelector((state) => state.page.rateArchive);
	const dispatch = useDispatch();

	return {
		state: rateArchive,
		actions: customActions_page.rateArchive,
		dispatch: dispatch,
		setState: (values = {}, scope = '') => dispatch(actions.page_rateArchive_set(values, scope)),
		clearState: (values = {}, scope = '') => dispatch(actions.page_rateArchive_clear(values, scope)),
	};
};

//reception
export const usePage_reception = () => {
	const reception = useSelector((state) => state.page.reception);
	const dispatch = useDispatch();

	return {
		state: reception,
		actions: customActions_page.reception,
		dispatch: dispatch,
		setState: (values = {}, scope = '') => dispatch(actions.page_reception_set(values, scope)),
		clearState: (values = {}, scope = '') => dispatch(actions.page_reception_clear(values, scope)),
	};
};

//services
export const usePage_services = () => {
	const services = useSelector((state) => state.page.services);
	const dispatch = useDispatch();

	return {
		state: services,
		actions: customActions_page.services,
		dispatch: dispatch,
		setState: (values = {}, scope = '') => dispatch(actions.page_services_set(values, scope)),
		clearState: (values = {}, scope = '') => dispatch(actions.page_services_clear(values, scope)),
	};
};

//survey
export const usePage_survey = () => {
	const survey = useSelector((state) => state.page.survey);
	const dispatch = useDispatch();

	return {
		state: survey,
		actions: customActions_page.survey,
		dispatch: dispatch,
		setState: (values = {}, scope = '') => dispatch(actions.page_survey_set(values, scope)),
		clearState: (values = {}, scope = '') => dispatch(actions.page_survey_clear(values, scope)),
	};
};

//adminNews
export const usePage_adminNews = () => {
	const adminNews = useSelector((state) => state.page.adminNews);
	const dispatch = useDispatch();

	return {
		state: adminNews,
		actions: customActions_page.adminNews,
		dispatch: dispatch,
		setState: (values = {}, scope = '') => dispatch(actions.page_adminNews_set(values, scope)),
		clearState: (values = {}, scope = '') => dispatch(actions.page_adminNews_clear(values, scope)),
	};
};

//adminEvent
export const usePage_adminEvent = () => {
	const adminEvent = useSelector((state) => state.page.adminEvent);
	const dispatch = useDispatch();

	return {
		state: adminEvent,
		actions: customActions_page.adminEvent,
		dispatch: dispatch,
		setState: (values = {}, scope = '') => dispatch(actions.page_adminEvent_set(values, scope)),
		clearState: (values = {}, scope = '') => dispatch(actions.page_adminEvent_clear(values, scope)),
	};
};

//adminSetting
export const usePage_adminSetting = () => {
	const adminSetting = useSelector((state) => state.page.adminSetting);
	const dispatch = useDispatch();

	return {
		state: adminSetting,
		actions: customActions_page.adminSetting,
		dispatch: dispatch,
		setState: (values = {}, scope = '') => dispatch(actions.page_adminSetting_set(values, scope)),
		clearState: (values = {}, scope = '') => dispatch(actions.page_adminSetting_clear(values, scope)),
	};
};

//adminReception
export const usePage_adminReception = () => {
	const adminReception = useSelector((state) => state.page.adminReception);
	const dispatch = useDispatch();

	return {
		state: adminReception,
		actions: customActions_page.adminReception,
		dispatch: dispatch,
		setState: (values = {}, scope = '') => dispatch(actions.page_adminReception_set(values, scope)),
		clearState: (values = {}, scope = '') => dispatch(actions.page_adminReception_clear(values, scope)),
	};
};

//adminScreen
export const usePage_adminScreen = () => {
	const adminScreen = useSelector((state) => state.page.adminScreen);
	const dispatch = useDispatch();

	return {
		state: adminScreen,
		actions: customActions_page.adminScreen,
		dispatch: dispatch,
		setState: (values = {}, scope = '') => dispatch(actions.page_adminScreen_set(values, scope)),
		clearState: (values = {}, scope = '') => dispatch(actions.page_adminScreen_clear(values, scope)),
	};
};

